<template>
  <aside class="left-sidebar">
    <!-- 실제 내용 -->
    <div>
      <div class="promotion-banner">
        <!-- 기존 프로모션 배너 코드 유지 -->
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="m480-143.85-98.85 34.23q-5.46 2-10.69 2.62-5.23.62-10.46.62-25.85 0-45.23-18.27-19.39-18.27-19.39-46.35v-187.23l-116.3-187.46q-5.23-8.46-7.46-17.04-2.24-8.58-2.24-17.27t2.24-17.27q2.23-8.58 7.46-17.04l120.61-195.38q8.69-14.93 23.23-22.62 14.54-7.69 31.7-7.69h250.76q17.16 0 31.7 7.69t23.23 22.62l120.61 195.38q5.23 8.46 7.46 17.04 2.24 8.58 2.24 17.27t-2.24 17.27q-2.23 8.58-7.46 17.04l-116.3 187.46V-171q0 28.08-19.39 46.35-19.38 18.27-45.23 18.27-5.23 0-10.46-.62t-10.69-2.62L480-143.85Zm0-43.23 112.31 37.62q12.31 3.84 22.31-3.08 10-6.92 10-20V-320H335.38v147.46q0 13.08 10 20t22.31 3.08L480-187.08ZM354.62-360h250.76q6.16 0 11.54-3.08 5.39-3.07 9.23-8.46l121.39-195.38q3.84-6.16 3.84-13.08t-3.84-13.08L626.15-788.46q-3.84-5.39-9.23-8.46-5.38-3.08-11.54-3.08H354.62q-6.16 0-11.54 3.08-5.39 3.07-9.23 8.46L212.46-593.08q-3.84 6.16-3.84 13.08t3.84 13.08l121.39 195.38q3.84 5.39 9.23 8.46 5.38 3.08 11.54 3.08ZM438-501.54l155.62-156.61q5.61-5.85 13.65-5.73 8.04.11 13.88 5.73 6.62 5.84 6.35 14.27-.27 8.42-6.12 14.26L460.62-468.08q-9.7 9.7-22.62 9.7-12.92 0-22.62-9.7l-76.53-75.77q-6.62-5.84-6.62-13.88 0-8.04 6.62-14.65 6.61-6.62 14.27-6.62 7.65 0 14.26 6.62L438-501.54ZM480-320H335.38h289.24H480Z"/></svg>
        <p>품질부터 서비스까지, 믿을 수 있는 정직한 쇼핑몰</p>
      </div>

      <!-- 카테고리 메뉴 부분 -->
      <div class="category-menu">
        <ul class="menu-list">
          <h3>추천 카테고리</h3>
          <!-- 로딩 중 표시 -->
          <li class="menu-item loading-item" v-if="categoryLoading">
            <div class="category-loading">
              <i class="bi bi-arrow-repeat spinning"></i>
              <span>카테고리 로딩 중...</span>
            </div>
          </li>
          <!-- 카테고리 목록 -->
          <li class="menu-item" :class="{ 'is-active': isActiveCategory(category.id) }" v-for="category in recommendedCategories" :key="category.id" v-else>
            <router-link :to="`/products?category=${category.id}`" class="menu-link">
              {{ category.name }}
            </router-link>
          </li>
          <li class="menu-item" v-if="recommendedCategories.length === 0 && !categoryLoading">
            <span class="menu-link">카테고리가 없습니다</span>
          </li>
        </ul>
      </div>

      <!-- 하단 메뉴 아이콘 링크 -->
      <div class="bottom-menu">
        <div class="menu-group">
          <button class="menu-icon-btn" @click="toggleSubMenu('order')">
            <i class="bi bi-cart"></i>
            <span>주문하기</span>
            <i class="bi" :class="activeMenu === 'order' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>

          <div class="sub-menu" v-if="activeMenu === 'order'">
            <router-link to="/cart" class="sub-menu-link">장바구니</router-link>
            <router-link to="/mypage/orderhistory" class="sub-menu-link">주문조회</router-link>
            <router-link to="/mypage/reorder/default" class="sub-menu-link">주문이력(재주문)</router-link>
            <router-link to="/mypage/delivery" class="sub-menu-link">배송조회</router-link>
            <router-link to="/mypage/return" class="sub-menu-link">취소/반품</router-link>
            <router-link to="/mypage/quotes" class="sub-menu-link">견적서 내역</router-link>
            <router-link to="/mypage/quote-requests" class="sub-menu-link">견적요청</router-link>
          </div>
        </div>

        <div class="menu-divider"></div>

        <div class="menu-group">
          <button class="menu-icon-btn" @click="toggleSubMenu('mypage')">
            <i class="bi bi-person-circle"></i>
            <span>마이페이지</span>
            <i class="bi" :class="activeMenu === 'mypage' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>

          <div class="sub-menu" v-if="activeMenu === 'mypage'">
            <router-link to="/mypage/profile" class="sub-menu-link">회원정보</router-link>
<!--            <a href="/mypage/points" class="sub-menu-link">쿠폰</a>-->
            <router-link to="/mypage/wishlist" class="sub-menu-link">찜 목록</router-link>
<!--            <a href="/mypage/ledger" class="sub-menu-link">원장조회</a>-->
            <router-link to="/mypage/notification-settings" class="sub-menu-link">알림설정</router-link>
            <router-link to="/mypage/withdrawal" class="sub-menu-link">회원탈퇴</router-link>
          </div>
        </div>

<!--        <div class="menu-divider"></div>-->

<!--        <div class="menu-group" >-->
<!--          <button class="menu-icon-btn" @click="toggleSubMenu('return')">-->
<!--            <i class="bi bi-box-seam"></i>-->
<!--            <span>반품/교환</span>-->
<!--            <i class="bi" :class="activeMenu === 'return' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>-->
<!--          </button>-->

<!--          <div class="sub-menu" v-if="activeMenu === 'return'">-->
<!--            <a href="/mypage/return" class="sub-menu-link">반품신청</a>-->
<!--            <a href="/mypage/return" class="sub-menu-link">교환신청</a>-->
<!--            <a href="/mypage/return" class="sub-menu-link">반품/교환 조회</a>-->
<!--          </div>-->
<!--        </div>-->

        <div class="menu-divider"></div>

        <div class="menu-group">
          <button class="menu-icon-btn" @click="toggleSubMenu('promotion')">
            <i class="bi bi-calendar-event"></i>
            <span>프로모션</span>
            <i class="bi" :class="activeMenu === 'promotion' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>

          <div class="sub-menu" v-if="activeMenu === 'promotion'">
<!--            <a href="#" class="sub-menu-link">이벤트</a>-->
<!--            <a href="/promotions" class="sub-menu-link">프로모션</a>-->
            <router-link to="/mypage/coupons" class="sub-menu-link">쿠폰</router-link>
          </div>
        </div>

        <div class="menu-divider"></div>

        <div class="menu-group">
          <button class="menu-icon-btn" @click="toggleSubMenu('cs')">
            <i class="bi bi-headset"></i>
            <span>고객센터</span>
            <i class="bi" :class="activeMenu === 'cs' ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </button>

          <div class="sub-menu" v-if="activeMenu === 'cs'">
            <router-link to="/mypage/notices" class="sub-menu-link">공지사항</router-link>
            <router-link to="/mypage/faq" class="sub-menu-link">FAQ</router-link>
            <router-link to="/mypage/inquiries" class="sub-menu-link">1:1 문의</router-link>
          </div>
        </div>

        <div class="menu-divider"></div>

        <!-- 추가 버튼 영역 -->
        <div class="additional-menus">
          <button class="guide-btn">
            <i class="bi bi-question-circle"></i>
            <span>주문 가이드</span>
          </button>

          <button class="delivery-btn">
            <i class="bi bi-truck"></i>
            <span>배송 안내</span>
          </button>
        </div>

        <!-- SNS 링크 영역 -->
        <div class="sns-links">
          <span class="sns-title">마이툴 SNS</span>
          <div class="sns-icons">
            <a href="#" class="sns-icon instagram">
              <i class="bi bi-instagram"></i>
            </a>
            <a href="#" class="sns-icon youtube">
              <i class="bi bi-youtube"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { getShopCategories } from '@/services/shopCategoryService';

export default {
  name: 'LeftSidebar',
  data() {
    return {
      activeMenu: null, // 현재 활성화된 메뉴
      recommendedCategories: [], // 추천 카테고리 (2차 카테고리)
      categoryLoading: true
    }
  },
  mounted() {
    // 카테고리 데이터 로드
    this.fetchCategories();
  },
  watch: {
    // 현재 페이지가 속한 메뉴를 펼쳐 둠 (새로고침·주소 직접 입력 시에도 유지)
    '$route.path': {
      handler(path) {
        const menu = this.getMenuForPath(path);
        if (menu) {
          this.activeMenu = menu;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 현재 주소(/products?category=ID)의 카테고리인지 (router-link 자동 표시는 ? 뒤 값을 구분하지 못함)
    isActiveCategory(categoryId) {
      return this.$route.path === '/products' && String(this.$route.query.category) === String(categoryId);
    },

    // 경로 → 하위 메뉴 그룹
    getMenuForPath(path) {
      if (path === '/cart' || ['/mypage/orderhistory', '/mypage/reorder', '/mypage/delivery', '/mypage/return',
        '/mypage/quotes', '/mypage/quote-requests'].some(p => path.startsWith(p))) {
        return 'order';
      }
      if (['/mypage/profile', '/mypage/wishlist', '/mypage/notification-settings', '/mypage/withdrawal'].some(p => path.startsWith(p))) {
        return 'mypage';
      }
      if (path.startsWith('/mypage/coupons')) {
        return 'promotion';
      }
      if (path.startsWith('/mypage/notices') || path.startsWith('/mypage/faq') || path.startsWith('/mypage/inquiries')) {
        return 'cs';
      }
      return null;
    },

    toggleSubMenu(menuName) {
      // 같은 메뉴를 클릭하면 닫기, 다른 메뉴를 클릭하면 해당 메뉴 열기
      if (this.activeMenu === menuName) {
        this.activeMenu = null;
      } else {
        this.activeMenu = menuName;
      }
    },

    async fetchCategories() {
      try {
        this.categoryLoading = true;
        const data = await getShopCategories();

        if (data && Array.isArray(data)) {
          let firstLevelCategories = [];

          // "전체카테고리" 안에 1차 카테고리(대분류)가 있는 경우
          if (data.length === 1 &&
              data[0].name === '전체카테고리' &&
              data[0].children &&
              data[0].children.length > 0) {
            firstLevelCategories = data[0].children;
          } else {
            firstLevelCategories = data;
          }

          // 1차 카테고리(대분류) 표시 - 활성화된 것만
          this.recommendedCategories = firstLevelCategories
            .filter(cat => cat.active === undefined || cat.active === true)
            .map(cat => ({
              id: cat.id,
              name: cat.name
            }))
            .slice(0, 10); // 최대 10개
        }
      } catch (error) {
        console.error('카테고리 로드 실패:', error);
        this.recommendedCategories = [];
      } finally {
        this.categoryLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.left-sidebar {
  display: flex;
  flex-direction: column;
  width: 250px;
  max-width: 250px;
  background-color: #333; /* #eeeeee에서 #333으로 변경 - 이미지의 배경색과 일치 */
  color: white;
  height: 100%; /* 부모 컨테이너의 높이를 채움 */
  overflow-y: auto; /* 내용이 많을 때 스크롤 활성화 */
  margin-bottom: 0; /* 하단 여백 제거 */
  padding-bottom: 0; /* 하단 패딩 제거 */
}

.sub-menu {
  background-color: #2a2a2a;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

@keyframes slideDown {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 200px;
    opacity: 1;
  }
}

/* 하단 메뉴 스타일 */
.bottom-menu {
  background-color: #333;
  padding: 5px 0;
  flex-grow: 1; /* 남은 공간을 차지하도록 설정 */
  display: flex;
  flex-direction: column;
  margin-bottom: 0; /* 하단 여백 제거 */
  padding-bottom: 0; /* 하단 패딩 제거 */
}

.menu-group {
  padding: 0;
}

.menu-icon-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* space-between에서 flex-start로 변경 */
  background: none;
  border: none;
  color: white;
  width: 100%;
  padding: 12px 20px;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s;
}

.menu-icon-btn span {
  font-size: 14px;
  text-align: left;
  padding-left:15px;
  flex-grow: 1; /* 남은 공간을 차지하도록 설정 */
  margin-right: auto; /* 오른쪽 여백을 자동으로 설정 */
}

.menu-icon-btn i:last-child {
  margin-left: auto; /* 화살표 아이콘을 오른쪽으로 밀기 */
}
.menu-divider {
  height: 1px;
  background-color: #444;
  margin: 0;
}



.sub-menu-link {
  display: block;
  color: #ccc;
  text-decoration: none;
  padding: 10px 40px;
  font-size: 13px;
  transition: background-color 0.2s;
}

.sub-menu-link:hover {
  background-color: #3a3a3a;
  color: white;
}

/* 현재 페이지 표시: 하위 메뉴(router-link 자동 클래스)와 추천 카테고리(is-active) */
.sub-menu-link.router-link-exact-active,
.menu-item.is-active {
  background-color: #3a3a3a;
  box-shadow: inset 3px 0 0 #ffc107; /* 왼쪽 노란 세로줄 (헤더 강조색) */
}

.sub-menu-link.router-link-exact-active,
.menu-item.is-active .menu-link {
  color: white;
  font-weight: 700;
}

/* 나머지 스타일 유지 */
.additional-menus {
  padding: 5px 0;
  border-top: 1px solid #444;
  margin-top: 10px;
}

.guide-btn, .delivery-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #ccc;
  width: 100%;
  padding: 8px 20px;
  text-align: left;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s;
}

.guide-btn:hover, .delivery-btn:hover {
  background-color: #444;
  color: white;
}

.guide-btn i, .delivery-btn i {
  margin-right: 10px;
  font-size: 16px;
}

/* 마지막 요소의 여백 제거 */
.sns-links {
  padding: 15px 20px;
  border-top: 1px solid #444;
  margin-top: 10px;
  margin-bottom: 0; /* 하단 여백 제거 */
  padding-bottom: 0; /* 하단 패딩 제거 */
}

.sns-title {
  display: block;
  color: #ccc;
  font-size: 13px;
  margin-bottom: 10px;
}

.sns-icons {
  display: flex;
}

.sns-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
  color: white;
  text-decoration: none;
}

.instagram {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
}

.youtube {
  background-color: #FF0000;
}
/* 카테고리 메뉴 스타일 */
.category-menu {
  padding: 5px 0;
  border-bottom: 1px solid #444;
  background-color: #2c2c2c;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.menu-list h3{
  font-size:15px;
  padding:0 20px;
}
.menu-item {
  padding: 2px 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;
}

.menu-item:hover {
  background-color: #444;
}

/* 프로모션 배너 스타일 */
.promotion-banner {
  background-color: #222;
  padding: 2px;
  text-align: center;
  border-bottom: 1px solid #444;
}
.promotion-banner p{
  font-size:14px;color:#fff;font-weight:bold;text-align: center;
}
/* 모바일에서 숨기기 */
@media (max-width: 768px) {
  .left-sidebar {
    display: none;
  }
}

.menu-link {
  display: block;
  color: #ccc;
  text-decoration: none;
  padding: 4px 0;         /* 상하 여백 */
  line-height: 1.3;       /* 줄간격 */
  transition: color 0.2s, background-color 0.2s;
}

.menu-link:hover {
  color: #ffffff;
  background-color: #444;
}

/* 카테고리 로딩 스타일 */
.category-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #aaa;
  font-size: 13px;
  padding: 10px 0;
}

.category-loading i {
  font-size: 16px;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.loading-item {
  padding: 5px 20px;
}

</style>